var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBkgSection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1902,
    height: 1038,
    viewBox: "0 0 1902 1038",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1410_236)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1410_236)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.199951 225.2C740.211 472.63 1166.18 474.687 1902.26 225.2V795.2C1164.12 509.664 738.286 515.727 0.199951 800.7V225.2Z",
    fill: "url(#paint0_radial_1410_236)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_1410_236)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1179.55 456.7C1307.84 456.7 1435.51 438.902 1558.9 403.816L1902.2 306.2V720.2L1552.76 611.925C1433.41 574.945 1309.61 554.261 1184.72 550.435L981.2 544.2V456.7H1179.55Z",
    fill: "url(#paint1_linear_1410_236)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_1410_236)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M745.915 456.7C625.135 456.7 504.872 440.924 388.178 409.772L0.199951 306.2V720.2L393.69 605.734C506.749 572.845 623.536 554.487 741.233 551.102L981.2 544.2V456.7H745.915Z",
    fill: "url(#paint2_linear_1410_236)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_1410_236)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M580.2 516.608C580.2 525.653 573.768 533.42 564.881 535.105L0.199951 642.2V384.2L565.096 498.153C573.882 499.926 580.2 507.646 580.2 516.608Z",
    fill: "#76BDFF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_1410_236)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1322.2 516.608C1322.2 525.653 1328.63 533.42 1337.52 535.105L1902.2 642.2V384.2L1337.3 498.153C1328.52 499.926 1322.2 507.646 1322.2 516.608Z",
    fill: "#76BDFF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1410_236",
    x: -225,
    y: 0.000198364,
    width: 2352.46,
    height: 1025.9,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 112.6,
    result: "effect1_foregroundBlur_1410_236"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1410_236",
    x: 795.3,
    y: 120.3,
    width: 1292.8,
    height: 785.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 92.95,
    result: "effect1_foregroundBlur_1410_236"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_1410_236",
    x: -185.7,
    y: 120.3,
    width: 1352.8,
    height: 785.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 92.95,
    result: "effect1_foregroundBlur_1410_236"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_1410_236",
    x: -148.2,
    y: 235.8,
    width: 876.8,
    height: 554.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 74.2,
    result: "effect1_foregroundBlur_1410_236"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_1410_236",
    x: 1173.8,
    y: 235.8,
    width: 876.8,
    height: 554.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 74.2,
    result: "effect1_foregroundBlur_1410_236"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1410_236",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(945.2 487.7) scale(945 824.693)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#003566"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.509615,
    stopColor: "#004F98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.841346,
    stopColor: "#0037ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42A4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1410_236",
    x1: 1893.75,
    y1: 502.2,
    x2: 981.2,
    y2: 499.997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004F99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0084FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1410_236",
    x1: 9.19995,
    y1: 502.2,
    x2: 981.2,
    y2: 499.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004F99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0084FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1410_236"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1902,
    height: 1038,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBkgSection);
export default __webpack_public_path__ + "static/media/bkgSection.78feeb277325860b29c1ddc71cf1e00f.svg";
export { ForwardRef as ReactComponent };